import { makeStyles, createStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) =>
	createStyles({
		root: {
			flexGrow: 1,
		},
		paper: {
			padding: theme.spacing(2),
			paddingBottom: 95,
			textAlign: 'center',
			color: theme.palette.text.secondary,
		},
		menuButton: {
			marginRight: theme.spacing(2),
		},
		title: {
			flexGrow: 1,
			fontWeight: 400,
			paddingTop: 10,
			paddingLeft: 0,
			marginLeft:0,
			color: theme.palette.secondary.main,
			[theme.breakpoints.up('xs')]: {
				fontSize: 20,
			},
			[theme.breakpoints.up('sm')]: {
				fontSize: 35,
			},
			[theme.breakpoints.up('lg')]: {
		
				fontSize: 60,
			},
		},
		svgLogo: {
			marginTop: 0,
			marginRight: 10,
			//padding: 5,
			height: 100,
			[theme.breakpoints.up('xs')]: {
				height: 70,
				marginRight: 0,
			},
			[theme.breakpoints.up('md')]: {
				height: 100,
			},
		},
		orange: {
			color: theme.palette.getContrastText(theme.palette.secondary.dark),
			backgroundColor: theme.palette.secondary.light,
		},
		header: {},
		footer: {
			backgroundColor: theme.palette.primary.main,
			color: theme.palette.primary.contrastText,
			padding: 10,
			top: 'auto',
			bottom: 0,
			textAlign: 'center',
		},
	})
);
